import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { ModuleInfoContext } from "./ModuleInfoContext";

export const useModuleInfoProvider = () => {
  const context = useContext(ModuleInfoContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useModuleInfoProvider",
      "ModuleInfoContext"
    );
  }

  return context;
};
